module.exports = __webpack_public_path__ + "img/construwood-w.9350deaa.jpg";